var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVersion11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document.filled.17",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2v3.5a2.5 2.5 0 002.336 2.495L10.5 8H14v5.5a1.5 1.5 0 01-1.5 1.5h-8A1.5 1.5 0 013 13.5v-10A1.5 1.5 0 014.5 2H8z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7h-3.077c-.669 0-.911-.07-1.156-.2a1.363 1.363 0 01-.567-.567c-.13-.245-.2-.487-.2-1.156V2h.38c.259 0 .348.01.447.032a.87.87 0 01.273.113c.086.054.156.11.338.293l3.124 3.124c.182.182.239.252.293.338a.87.87 0 01.113.273c.023.1.032.188.032.447V7z",
    id: "Rectangle",
    opacity: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersion11);
export default __webpack_public_path__ + "static/media/version-11.ebd0533a.svg";
export { ForwardRef as ReactComponent };